import { combineReducers } from 'redux';

import {
  getOrderListRequest,
  getOrderListFail,
  getOrderListSuccess,
  clearOrderList,
  setOrderListDirty,
} from '../actions';

import { OrderAction, OrderListState } from '../types';
import { Reducer } from '../../../types';
import { stripItems } from '../../../../utility/store';

type ReducerOf<T extends keyof OrderListState> = Reducer<OrderListState, OrderAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getOrderListRequest.type:
      return state ? stripItems(state) : null;

    case getOrderListSuccess.type:
      return action.payload;

    case clearOrderList.type:
      return null;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getOrderListRequest.type:
      return true;

    case getOrderListSuccess.type:
    case getOrderListFail.type:
      return false;

    default:
      return state;
  }
};

const dirty: ReducerOf<'dirty'> = (state = false, action) => {
  switch (action.type) {
    case setOrderListDirty.type:
      return action.payload;

    case getOrderListRequest.type:
    case getOrderListFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case getOrderListFail.type:
      return true;

    case getOrderListRequest.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<OrderListState>({
  data,
  loading,
  dirty,
  error,
});
